import { useLayout } from '@approvalmax/ui/src/components';

import useNewOrganisationData from './hooks/useNewOrganisationData';

const NewOrganisationPage = () => {
    useLayout({ hasHeader: false, hasDrawer: false });
    useNewOrganisationData();

    return null;
};

export default NewOrganisationPage;
